import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=d74992ca&scoped=true"
import script from "./privacy_policy.js?vue&type=script&lang=js&external"
export * from "./privacy_policy.js?vue&type=script&lang=js&external"
import style0 from "./privacy_policy.scss?vue&type=style&index=0&id=d74992ca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74992ca",
  null
  
)

export default component.exports